import React from 'react';
import { SpaceProps } from 'styled-system';
import { Body2, Headline } from '../Typography/Typography';
import Box from '../Box/Box';
import Underline from '../Underline/Underline';
import ConditionalWrap from 'conditional-wrap';
import Image from '../Image/Image';
import { rem } from 'polished';

interface StyledFeatureTabProps extends SpaceProps {
    isActive?: boolean;
    item: any;
    duration: number;
}

const FeatureTab: React.FC<StyledFeatureTabProps> = ({
    isActive,
    item,
    duration,
}) => {
    return (
        <ConditionalWrap
            condition={isActive}
            wrap={(children) => (
                <Underline
                    color={({ theme }) => theme.colors.primary['100']}
                    thickness="2"
                    verticalSpacing="-6px"
                    duration={duration}
                >
                    {children}
                </Underline>
            )}
        >
            <Box
                bg={isActive && 'primary.1600'}
                color="neutral.white"
                borderRadius="4px"
                px={rem('24px')}
                py={rem('16px')}
                _hover={{
                    backgroundColor: 'primary.1700',
                    cursor: 'pointer',
                }}
            >
                <Box
                    display="flex"
                    alignItems="center"
                    borderBottom={isActive && '1px solid'}
                    borderBottomColor={isActive && 'primary.500'}
                    pt={isActive && rem('8px')}
                    pb={isActive && rem('16px')}
                    gap={rem(10)}
                >
                    <Image img={item.icon} />
                    <Headline color="neutral.white">
                        {item?.title?.text}
                    </Headline>
                </Box>
                {isActive && (
                    <Body2 color="primary.300" py={rem('8px')}>
                        {item.description}
                    </Body2>
                )}
            </Box>
        </ConditionalWrap>
    );
};

export default FeatureTab;
